angular.module('sample.widgets.assetAnalysisChart', ['adf.provider'])
    .config(['dashboardProvider', function (dashboardProvider) {
        dashboardProvider
            .widget('asset-analysis-chart', {
                id: 'asset-analysis-chart',
                title: 'Assets in EICAssetMap',
                description: 'Shows global asset analysis by region and asset type',
                controller: 'AssetAnalysisChartWidgetController',
                template: '<div id="assetAnalysisChartWidget"><eic-asset-analysis-chart legend-position="top"></eic-asset-analysis-chart></div>'
            });
    }])
    .controller('AssetAnalysisChartWidgetController', ['$scope',
        function ($scope) {
            $scope.componentName = 'AssetAnalysisChartWidgetController';

            $scope.$on('$viewContentLoaded', function () {
            });
            $scope.$emit('$viewContentLoaded');
        }]);
